/**
 * Дверь платформенного токена в standalone: замена ОТВЕРГНУТОГО токена.
 *
 * Вход по токену (стор пуст) живёт в карточке входа — ссылкой рядом с «Войти через
 * Aseller» (`pages/login/LoginPage.tsx`). Здесь остаётся ровно то, чего карточка
 * дать не может: отвергнутый токен у пользователя, который уже внутри, — его сессия
 * держится на этом токене, и заменить его больше негде. Поэтому гейт смонтирован
 * ВЫШЕ развилки личности (`app/App.tsx`).
 *
 * Поднимается ИЗ СТОРА, а не из ответа бэкенда: продюсера детали
 * `platform_token_required` у модуля нет и не будет (нет роута, которому
 * платформенный токен нужен по делу), поэтому реактивный путь «сначала ошибка,
 * потом подсказка» здесь неисполним.
 *
 * ⚠️ Режима компонент НЕ проверяет, и это осознанно: вопрос «показывать ли двери
 * входа» решён один раз — тем, что в embed не монтируется ни этот гейт, ни форма
 * логина (`app/App.tsx`, `createEmbedMode`). Собственная сверка режима была бы
 * вторым ответом на тот же вопрос, да ещё и нереактивным: `isStandaloneMode()`
 * читает модульный флаг, смена которого перерисовку не вызывает.
 */

import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Button, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { platformTokenStore } from '../../shared/api/client';
import PlatformSsoButton from '../platform-sso/PlatformSsoButton';
import PlatformTokenModal from './PlatformTokenModal';
import { usePlatformTokenSnapshot } from './usePlatformTokenSnapshot';

const PlatformTokenGate: React.FC = () => {
  const { t } = useTranslation();
  const { status, expiredPromptDismissed } = usePlatformTokenSnapshot();
  const [open, setOpen] = useState(false);

  // Отвергнутый платформой refresh — единственный случай, когда диалог
  // открывается сам: пользователь уже вложился в этот канал, и молча его
  // потерять хуже, чем один раз показать модал. Закрыл — больше не открываем,
  // CTA при этом остаётся.
  useEffect(() => {
    if (status === 'expired' && !expiredPromptDismissed) setOpen(true);
  }, [status, expiredPromptDismissed]);

  const handleClose = useCallback(() => {
    setOpen(false);
    if (platformTokenStore.status === 'expired') platformTokenStore.dismissExpiredPrompt();
  }, []);

  if (status === 'ready') return null;
  // Токена нет — дверь к нему живёт в карточке входа (`pages/login/LoginPage.tsx`,
  // ссылка «Войти по токену платформы» рядом с кнопкой SSO): баннер над экраном входа
  // дублировал кнопку «Войти через Aseller» и кричал «токен не указан» человеку,
  // который пришёл войти паролем. Вошедшему — тем более: платформенный токен здесь
  // ВХОД, и бэкенду модуля он не нужен ни на одном роуте. Баннер остаётся ровно
  // для отвергнутого токена (`expired`): у платформенной личности сессия держится
  // на нём, и заменить его после входа больше негде.
  if (status === 'missing') return null;

  return (
    <>
      <Alert
        type="warning"
        showIcon
        style={{ textAlign: 'left' }}
        message={t('platform.ctaExpired')}
        description={t('platform.ctaHint')}
        action={
          <Space size={4}>
            {/* Вход через платформу — основная дверь; ручной токен остаётся запасной,
                пока SSO не выкачен на stage и prod платформы. Кнопка сама себя
                скрывает, если вход не настроен на этом контуре. */}
            <PlatformSsoButton size="small" />
            <Button size="small" type="link" onClick={() => setOpen(true)}>
              {t('platform.provideToken')}
            </Button>
          </Space>
        }
      />
      <PlatformTokenModal open={open} onClose={handleClose} />
    </>
  );
};

export default PlatformTokenGate;
